import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { createSelector } from 'reselect';

const ID_128GB_1M_TRIAL = '128G1m_trial';

const getTrialTarrif128Gb = createSelector(ProductsSelectors.getTrialTariffs, (products) => {
    return products.find((tariff) => tariff.products.some((product) => product.id === ID_128GB_1M_TRIAL));
});

export const getTrialProduct128Gb1m = createSelector(getTrialTarrif128Gb, (tariff) => {
    return tariff?.products?.find((product) => product.id === ID_128GB_1M_TRIAL);
});
